import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting1',
  templateUrl: './setting1.component.html',
  styleUrls: ['./setting1.component.scss']
})
export class Setting1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
